module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Contents_Page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('i', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "br"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Introduction#s1",
      "id": "r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Chapter1#s2",
      "id": "r2"
    }
  }, [_c('i', [_vm._v("The Mysterious Affair at Styles")]), _vm._v(", Agatha Christie (1915)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08_Chapter2#s3",
      "id": "r3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Yellow Wallpaper")]), _vm._v(", Charlotte Perkins Gilman (1892)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_Chapter3#s4",
      "id": "r4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Why I Wrote “The Yellow Wallpaper")]), _vm._v(",” Charlotte Perkins Gilman (1913)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_Chapter4#s5",
      "id": "r5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Letter to Fanny Knight")]), _vm._v(", Jane Austen (1814)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter5#s6",
      "id": "r6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cousin Phillis")]), _vm._v(", Elizabeth Gaskell (1864)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter6#s7",
      "id": "r7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Luella Miller")]), _vm._v(", Mary E. Wilkins Freeman (1903)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter7#s8",
      "id": "r8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Life")]), _vm._v(", Charlotte Brontë (1846)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter8#s9",
      "id": "r9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Stars")]), _vm._v(", Emily Brontë (1846)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter9#s10",
      "id": "r10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dreams")]), _vm._v(", Anne Brontë (1846)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter10#s11",
      "id": "r11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Silly Novels by Lady Novelists")]), _vm._v(", George Eliot (1856)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter11#s12",
      "id": "r12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From")]), _vm._v(" The Romance of the Forest, Ann Radcliffe (1791)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter12#s13",
      "id": "r13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Frankenstein")]), _vm._v(", Mary Shelley (1818)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter13#s14",
      "id": "r14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Contemplations")]), _vm._v(", Anne Bradstreet (1650)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter14#s15",
      "id": "r15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Call")]), _vm._v(", Grace MacGowan Cooke (1906)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter15#s16",
      "id": "r16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Goblin Market")]), _vm._v(", Christina Rossetti (1862)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter16#s17",
      "id": "r17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("On the Gulls’ Road")]), _vm._v(", Willa Cather (1908)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter17#s18",
      "id": "r18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Poems")]), _vm._v(", Emily Dickinson (1890)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter18#s19",
      "id": "r19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Voyage Out")]), _vm._v(", Virginia Woolf (1915)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter19#s20",
      "id": "r20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Renascence")]), _vm._v(", Edna St. Vincent Millay (1912)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter20#s21",
      "id": "r21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Xingu")]), _vm._v(", Edith Wharton (1916)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter21#s22",
      "id": "r22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Patterns")]), _vm._v(", Amy Lowell (1917)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter22#s23",
      "id": "r23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Garden Party")]), _vm._v(", Katherine Mansfield (1922)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter23#s24",
      "id": "r24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tender Buttons")]), _vm._v(", Gertrude Stein (1914)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter24#s25",
      "id": "r25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Shadowy Third")]), _vm._v(", Ellen Glasgow (1916)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter25#s26",
      "id": "r26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Afterward")]), _vm._v(", Edith Wharton (1910)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter26#s27",
      "id": "r27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Poems")]), _vm._v(", Sara Teasdale (1920)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338f3cce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Contents.vue
// module id = 72
// module chunks = 0